<template>
    <div>
        <div>
            <!-- <div class="content-table-title" style="margin-bottom: 20px">
                <span></span>
                <span>
                    <el-button type="primary" @click="Cart_WallHanging_Add()">加入壁挂到购物车</el-button>
                </span>
            </div> -->
            <div class="labelClassNameBoxcab">
                <el-descriptions title="" :column="3" border labelClassName="labelClassName">
                    <el-descriptions-item label="型号" span="3">
                        <div>
                            <el-select v-model="cabinetForm.Product_Model" placeholder="请选择" @change="getProduct_Model" class="el-select-medium">
                                <el-option v-for="item in ControlCabinetCabinetPTList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="点位" span="3">
                        <div class="">
                            <el-select v-model="cabinetForm.Product_PT" placeholder="请选择" class="el-select-medium" @change="selectForm">
                                <el-option v-for="item in ControlCabinetModelPTList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item :label="item.Name" v-for="(item, index) in GetWallHangingList" :key="index" span="3">
                        <div class="">
                            <div v-if="item.Code == 'board'">
                                <div v-for="(items, indexs) in item.boardOptions" :key="indexs" class="boardOptionsBox">
                                    数量：
                                    <el-input v-model="items.value" type="number" class="" :min="0" style="width: 200px; margin-right: 20px"></el-input>
                                    <span>名称：{{ items.name }}</span>
                                </div>
                                <div v-if="!item.boardOptions || item.boardOptions.length == 0">无</div>
                            </div>
                            <div v-else-if="item.Code == 'buy_amount_wall'">
                                <el-input-number v-model="item.Options.buy_amount_wall" :min="0" :max="9999999"></el-input-number>
                            </div>
                            <div v-else>
                                <el-select v-model="item.OptionsValue" placeholder="无" class="el-select-medium">
                                    <el-option v-for="(value, key) in item.Options" :key="key" :label="value" :value="key"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        Orders_Type: {
            type: [String, Number],
            default: 0
        },
        Orders_SourceCate: {
            type: [String, Number],
            default: 0
        },
        shoppingCarts: {
            type: [String, Number],
            default: 0
        },
        Customerid: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            ControlCabinetModelPTList: [], // 配柜点位
            cabinetForm: {
                Product_Model: '', // 型号
                Product_PT: '' // 点位
            },
            ControlCabinetCabinetPTList: [], // 配柜型号
            GetWallHangingList: [] // 壁挂
        };
    },
    created() {
        this.GetModel();
    },
    methods: {
        async GetModel() {
            await this.GetControlCabinetProductModel();
            this.cabinetForm.Product_Model = this.ControlCabinetCabinetPTList[0].value;
            await this.GetControlCabinetModelPT();
            this.cabinetForm.Product_PT = this.ControlCabinetModelPTList[0].value;
            this.GetWallHangingForm();
        },
        // 型号
        async GetControlCabinetProductModel() {
            let res = await this.$newsApi.order.GetControlCabinetProductModel({ SourceType: 'WallHanging' });
            if (res.data.Resultcode == 0) {
                this.ControlCabinetCabinetPTList = res.data.data.map((item) => {
                    return {
                        value: item,
                        label: item
                    };
                });
            }
        },
        getProduct_Model() {
            this.GetControlCabinetModelPT();
            this.GetWallHangingForm();
        },
        // 点位
        async GetControlCabinetModelPT() {
            let json = JSON.stringify({
                Product_Model: this.cabinetForm.Product_Model
            });
            let res = await this.$newsApi.order.GetControlCabinetModelPT({ json: json, SourceType: 'WallHanging' });
            if (res.data.Resultcode == 0) {
                const uniqueArr = [...new Set(res.data.data)];
                this.ControlCabinetModelPTList = uniqueArr.map((item) => {
                    return {
                        value: item,
                        label: item
                    };
                });
            }
        },
        selectForm() {
            this.GetWallHangingForm();
        },
        // 壁挂
        GetWallHangingForm() {
            let data = {
                Orders_Type: this.Orders_Type,
                Product_Model: this.cabinetForm.Product_Model,
                Product_PT: this.cabinetForm.Product_PT,
                Customerid: this.Customerid || 0 //客户ID
            };
            let json = JSON.stringify(data);
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order.GetWallHangingForm({ json: json }).then((res) => {
                this.$closeLoading(loadingInstance); // 关闭 loading
                if (res.data.Resultcode == 0) {
                    this.GetWallHangingList = res.data.data.EleList;
                    this.GetWallHangingList = this.GetWallHangingList.map((item) => {
                        if (item.Code == 'board') {
                            let arr = [];
                            let obj = {};
                            for (let key in item.Options) {
                                obj = {
                                    value: 0,
                                    label: key,
                                    name: item.Options[key]
                                };
                                arr.push(obj);
                            }
                            return {
                                ...item,
                                boardOptions: arr
                            };
                        } else if (item.Code == 'buy_amount_wall') {
                            return item;
                        } else {
                            this.$set(item, 'OptionsValue', Object.keys(item.Options)[0] || '0');
                            return item;
                        }
                    });
                }
            });
        },
        async Cart_WallHanging_Add() {
            let data = {
                WallHanging_Model: this.cabinetForm.Product_Model,
                WallHanging_PT: this.cabinetForm.Product_PT
            };
            this.GetWallHangingList.forEach((item) => {
                if (item.Code == 'board') {
                    item.boardOptions.forEach((items) => {
                        data[items.label] = items.value;
                    });
                } else if (item.Code == 'buy_amount_wall') {
                    data[item.Code] = item.Options.buy_amount_wall;
                } else {
                    data[item.Code] = item.OptionsValue;
                }
            });
            this.$emit('Cart_WallHanging_Add', data);
        },
        searchShoppingCart() {
            this.$emit('searchShoppingCart');
        }
    }
};
</script>

<style lang="scss" scoped>
.labelClassNameBoxcab {
    /deep/.labelClassName {
        width: 230px;
    }
}
.boardOptionsBox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
</style>